'use client'
import { StyledEngineProvider, AscendThemeProvider } from '@achieve/ascend'
import { createEmotionCache } from 'utils/emotion'
import { CacheProvider } from '@emotion/react'
import CssBaseline from '@mui/material/CssBaseline'
import { withNextFontUltramarine } from 'components/Fonts/Fonts'
import { SITE_ENVIRONMENTS } from 'constants/websites'
import { FdrTheme, AchieveTheme } from '@achieve/ascend'
import { AppRouterCacheProvider } from '@mui/material-nextjs/v14-appRouter'

let theme: typeof AchieveTheme | typeof FdrTheme
switch (process.env.NEXT_PUBLIC_SITE_ENVIRONMENT) {
  case SITE_ENVIRONMENTS.ACHIEVE:
    theme = withNextFontUltramarine(AchieveTheme)
    break
  case SITE_ENVIRONMENTS.FDR:
    theme = withNextFontUltramarine(FdrTheme)
    break
  default:
    theme = withNextFontUltramarine(AchieveTheme)
}
const cache = createEmotionCache()

export default function Providers({ children }: { children: React.ReactNode }) {
  return (
    <CacheProvider value={cache}>
      <StyledEngineProvider injectFirst>
        <AppRouterCacheProvider options={{ prepend: true }}>
          <AscendThemeProvider theme={theme}>
            <CssBaseline />
            {children}
          </AscendThemeProvider>
        </AppRouterCacheProvider>
      </StyledEngineProvider>
    </CacheProvider>
  )
}
